export default __webpack_public_path__ + "static/media/left_arrow.80d4cc98.svg";